export var ProductFeatureKeyEnum;
(function (ProductFeatureKeyEnum) {
    ProductFeatureKeyEnum[ProductFeatureKeyEnum["TRANSLATIONS"] = 0] = "TRANSLATIONS";
})(ProductFeatureKeyEnum || (ProductFeatureKeyEnum = {}));
